
import React, { useState, useEffect, useRef } from 'react';
import debounce from 'lodash/debounce';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primeicons/primeicons.css';

const HeaderSearch = ({ value, onChange, onClick }) => {
  const [inputValue, setInputValue] = useState(value || '');
  const debouncedOnChange = useRef(
    debounce((val) => {
      onChange(val);
    }, 300) // Adjust the debounce delay as needed
  ).current;

  // Handle input change
  const handleChange = (e) => {
    const newValue = e.target.value;
    setInputValue(newValue);
    debouncedOnChange(newValue);
  };
  const handleClick =(e)=>{
    const newValue = "";
    setInputValue(newValue);
    debouncedOnChange(newValue);
  }

  // Cleanup debounced function on unmount
  useEffect(() => {
    return () => {
      debouncedOnChange.cancel();
    };
  }, [debouncedOnChange]);

  return (
    <div className="flex flex-wrap justify-content-center gap-3 p-inputgroup search-container">
      <span className="p-input-icon-left p-input-icon-right search-wrapper">
        <i className="pi pi-search pt-18" />
        <InputText
          type="search"
          value={inputValue}
          onChange={handleChange}
          placeholder="Search"
          className="search-input"
        />
        {inputValue && (
          <Button
            icon="pi pi-times"
            className="p-button-secondary p-button-text cancel-button fs-13 clear-filter"
            onClick={handleClick}
          />
        )}
      </span>
    </div>
  );
};

export default HeaderSearch;


